
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.465.9H2.672C1.707.9.9 1.545.9 2.389c0 .843.807 1.489 1.773 1.489h24.791c.967 0 1.774-.646 1.774-1.49 0-.843-.82-1.488-1.773-1.488zM27.465 9.51H2.672C1.707 9.51.9 10.154.9 10.997c0 .844.807 1.489 1.773 1.489h24.791c.967 0 1.774-.645 1.774-1.489 0-.844-.82-1.489-1.773-1.489zM27.465 18.123H2.672c-.966 0-1.773.645-1.773 1.488 0 .844.807 1.49 1.773 1.49h24.791c.967 0 1.774-.646 1.774-1.49 0-.843-.82-1.488-1.773-1.488z","fill":"currentColor","stroke":"currentColor","stroke-width":".2"}})])
          )
        }
      }
    